import { defineMessages } from 'react-intl';
const i18nKey = 'CompanyTab';
const messages = defineMessages({
  companyTitle: {
    id: `${i18nKey}.companyTitle`,
    defaultMessage: 'Learn all about Coinbase',
    description: `
    #Component: TextHeadline
    #CharLimit: 60
    #Context: Text to learn about Coinbase`
  },
  companyDescription: {
    id: `${i18nKey}.companyDescription`,
    defaultMessage: "We're building the open financial system.",
    description: `
    #Component: TextLabel2
    #CharLimit: 100
    #Context: Description of Coinbase mission`
  },
  companyLinkText: {
    id: `${i18nKey}.companyLinkText`,
    defaultMessage: 'Create your account',
    description: `
    #Component: Link
    #CharLimit: 50
    #Context: Create your account button`
  },
  mobileNavBarLinkText: {
    id: `${i18nKey}.mobileNavBarLinkText`,
    defaultMessage: 'See all',
    description: `
    #Component: Button
    #CharLimit: 50
    #Context: Navbar link text for mobile`
  },
  companyAbout: {
    id: `${i18nKey}.companyAbout`,
    defaultMessage: 'About',
    description: `
    #Component: Link
    #CharLimit: 35
    #Context: About page label (CharLimit autocalculated to 35)`
  },
  companyAboutDescription: {
    id: `${i18nKey}.companyAboutDescription`,
    defaultMessage: 'Powering the crypto economy',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: About description (CharLimit autocalculated to 60)`
  },
  aboutLinkTitle: {
    id: `${i18nKey}.aboutLinkTitle`,
    defaultMessage: 'Powering the crypto economy',
    description: `
    #Component: Link
    #CharLimit: 65
    #Context: About page link description (CharLimit autocalculated to 65)`
  },
  careers: {
    id: `${i18nKey}.careers`,
    defaultMessage: 'Careers',
    description: `
    #Component: Link
    #CharLimit: 40
    #Context: Careers page label (CharLimit autocalculated to 40)`
  },
  careersDescription: {
    id: `${i18nKey}.careersDescription`,
    defaultMessage: 'Work with us',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: Careers description (CharLimit autocalculated to 60)`
  },
  careersLinkTitle: {
    id: `${i18nKey}.careersLinkTitle`,
    defaultMessage: 'Careers - Work with us',
    description: `
    #Component: Link
    #CharLimit: 50
    #Context: Careers page link description (CharLimit autocalculated to 50)`
  },
  affiliates: {
    id: `${i18nKey}.affiliates`,
    defaultMessage: 'Affiliates',
    description: `
    #Component: Link
    #CharLimit: 45
    #Context: Affiliates page label (CharLimit autocalculated to 45)`
  },
  affiliatesDescription: {
    id: `${i18nKey}.affiliatesDescription`,
    defaultMessage: 'Help introduce the world to crypto',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: Affiliates description (CharLimit autocalculated to 60)`
  },
  affiliatesLinkTitle: {
    id: `${i18nKey}.affiliatesLinkTitle`,
    defaultMessage: 'Affiliates - Help introduce the world to crypto',
    description: `
    #Component: Link
    #CharLimit: 70
    #Context: Affiliates page link description (CharLimit autocalculated to 70)`
  },
  support: {
    id: `${i18nKey}.support`,
    defaultMessage: 'Support',
    description: `
    #Component: Link
    #CharLimit: 40
    #Context: Support page label (CharLimit autocalculated to 40)`
  },
  supportDescription: {
    id: `${i18nKey}.supportDescription`,
    defaultMessage: 'Find answers to your questions',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: Support description (CharLimit autocalculated to 60)`
  },
  supportLinkTitle: {
    id: `${i18nKey}.supportLinkTitle`,
    defaultMessage: 'Support - Find answers to your questions',
    description: `
    #Component: Link
    #CharLimit: 50
    #Context: Support page link description (CharLimit autocalculated to 50)`
  },
  blog: {
    id: `${i18nKey}.blog`,
    defaultMessage: 'Blog',
    description: `
    #Component: Link
    #CharLimit: 35
    #Context: Blog page label (CharLimit autocalculated to 35)`
  },
  blogDescription: {
    id: `${i18nKey}.blogDescription`,
    defaultMessage: 'Read the latest from Coinbase',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: Blog description (CharLimit autocalculated to 60)`
  },
  blogLinkTitle: {
    id: `${i18nKey}.blogLinkTitle`,
    defaultMessage: 'Blog - Read the latest from Coinbase',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: Blog page link description (CharLimit autocalculated to 60)`
  },
  security: {
    id: `${i18nKey}.security`,
    defaultMessage: 'Security',
    description: `
    #Component: Link
    #CharLimit: 40
    #Context: Security page label (CharLimit autocalculated to 40)`
  },
  securityDescription: {
    id: `${i18nKey}.securityDescription`,
    defaultMessage: 'The most trusted & secure',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: Security description (CharLimit autocalculated to 60)`
  },
  securityLinkTitle: {
    id: `${i18nKey}.securityLinkTitle`,
    defaultMessage: 'Security - The most trusted & secure',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: Security page link description (CharLimit autocalculated to 60)`
  }
});
export { messages as default };
//# sourceMappingURL=messages.js.map
